module.exports = __webpack_public_path__ + "img/img-turfy-umajo-0.5b86bcad.png";